const coreLiveChatConfig = {
  // Worklet confidence above which a frame counts as speech. Lower it if speech
  // onset is missed, raise it if noise opens the mic.
  voiceConfidenceThreshold: parseFloat(
    process.env.REACT_APP_CORE_LIVE_CHAT_VOICE_CONFIDENCE_THRESHOLD ?? 0.15
  ),
  // Silence held before the turn is closed and sent. Too low clips mid-sentence
  // pauses; too high makes the character feel slow.
  silenceDurationMs: parseInt(
    process.env.REACT_APP_CORE_LIVE_CHAT_SILENCE_DURATION_MS ?? 2000
  ),
  // Floor for a sendable clip. A cough yields a near-empty blob, which the
  // agent answers with nothing, stalling the turn until the response timeout.
  minClipMs: parseInt(process.env.REACT_APP_CORE_LIVE_CHAT_MIN_CLIP_MS ?? 400),
  minClipBytes: parseInt(
    process.env.REACT_APP_CORE_LIVE_CHAT_MIN_CLIP_BYTES ?? 2048
  ),
  // Hard stop on one turn, so a stuck VAD cannot grow an unbounded frame.
  maxClipMs: parseInt(
    process.env.REACT_APP_CORE_LIVE_CHAT_MAX_CLIP_MS ?? 30000
  ), // 30 seconds
  // First supported entry wins. Safari has no webm and falls through to mp4.
  recorderMimeTypeCandidates: [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/mp4;codecs=mp4a.40.2',
    'audio/mp4'
  ]
};

export default coreLiveChatConfig;
